import React, { useEffect, useState } from "react";
import { TextField, Autocomplete, Avatar, ListItem, ListItemAvatar, ListItemText, InputAdornment } from "@mui/material";
import axios from "axios";

const CountrySelect = ({ setSelectedCountry, selectedCountry, countrylist }) => {
  const [inputValue, setInputValue] = useState("");
  const [openAutocomplete, setOpenAutocomplete] = useState(false);

  const customFilterOptions = () => {
    if (!inputValue.trim()) {
      return countrylist; // If input is empty, return all countries
    }
    return countrylist.filter((option) => option.country_name.toLowerCase().includes(inputValue.toLowerCase()));
  };
  useEffect(() => {
    const fetchUserCountry = async () => {
      try {
        const { data } = await axios.get("https://ipwho.is/");
        console.log({ data });

        if (!data.success) {
          throw new Error(data.message || "Failed to fetch country");
        }

        const userCountryCode = data.country_code.toLowerCase(); // Get country code

        // Try to find the country in countrylist using IP country code
        let defaultCountry = countrylist.find((country) => country.flag_icon.toLowerCase() === userCountryCode);

        // If not found, try to fallback to UAE
        if (!defaultCountry) {
          defaultCountry = countrylist.find((country) => country.flag_icon.toLowerCase() === "ae");
        }

        // Final fallback: just use the first country in the list
        if (!defaultCountry && countrylist.length > 0) {
          defaultCountry = countrylist[0];
        }

        if (defaultCountry) {
          setSelectedCountry(defaultCountry);
        }
      } catch (error) {
        console.error("Error fetching IP country:", error);

        // Fallback to UAE or first country in the list
        const fallback = countrylist.find((country) => country.flag_icon.toLowerCase() === "ae") || countrylist[0];

        if (fallback) {
          setSelectedCountry(fallback);
        }
      }
    };

    if (countrylist.length > 0) {
      fetchUserCountry();
    }
  }, [countrylist]);

  const handelInputClick = () => {
    console.log("hiiii");
  };
  return (
    <div style={{ width: "100%" }}>
      <Autocomplete
        options={customFilterOptions()} // Call the function here
        getOptionLabel={(option) => option.country_name}
        inputValue={inputValue}
        onInputChange={(event, newInputValue) => {
          setInputValue(newInputValue);
        }}
        open={openAutocomplete}
        onOpen={() => setOpenAutocomplete(true)}
        onClose={() => setOpenAutocomplete(false)}
        renderOption={(props, option) => (
          <li {...props} key={option._id}>
            <ListItem disableGutters>
              <ListItemAvatar>
                <Avatar
                  alt={option.country_name}
                  variant="square"
                  src={`https://flagcdn.com/28x21/${option.flag_icon.toLowerCase()}.png`}
                  sx={{ width: 28, height: 21 }}
                />
              </ListItemAvatar>
              <ListItemText primary={option.country_name} />
            </ListItem>
          </li>
        )}
        renderInput={(params) => (
          <TextField
            {...params}
            // label="Select Country"
            variant="filled"
            onFocus={() => {
              setInputValue(""); // Clear the text
              setSelectedCountry(null); // Clear selected value
              // setOpenAutocomplete(false); // Close suggestion box
            }}
            onMouseDown={() => {
              setInputValue(""); // Clear input text
              setSelectedCountry(null); // Clear selected country
              // setOpenAutocomplete(false); // Close dropdown
            }}
            sx={{
              background: "#FFFFFF",
              borderRadius: "10px",
              "& .MuiInputBase-root": {
                height: 48, // control overall height
                alignItems: "center", // align input and avatar vertically
              },
              "& .MuiInputBase-input": {
                marginTop: "-12px",
                display: "flex",
                alignItems: "center",
              },
            }}
            InputProps={{
              ...params.InputProps,
              startAdornment: selectedCountry ? (
                <InputAdornment position="end">
                  <Avatar
                    alt={selectedCountry.country_name}
                    variant="square"
                    src={`https://flagcdn.com/28x21/${selectedCountry.flag_icon.toLowerCase()}.png`}
                    sx={{ width: 28, height: 21, mr: 1, mt: -2 }}
                  />
                </InputAdornment>
              ) : null,
            }}
          />
        )}
        onChange={(event, value) => {
          setSelectedCountry(value);
        }}
        value={selectedCountry}
        isOptionEqualToValue={(option, value) => option._id === value?._id}
        clearOnEscape
        fullWidth
      />
    </div>
  );
};

export default CountrySelect;
